import React, { useCallback, useEffect, useState, useContext } from "react";
import { FiChevronsUp } from "react-icons/fi";
import { CursorContext } from "../context/CursorContext";

// 🧩 PageTop Component - Renders a scroll-to-top button inside a scrollable container
function PageTop({ scrollContainerRef }) {
  // 🧩 Get mouse event handlers from global cursor context
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  // 🧩 Track visibility of the button based on scroll position
  const [isVisible, setIsVisible] = useState(false);

  // 🧩 Scroll to top of scroll container smoothly
  const goToBtnClick = () => {
    scrollContainerRef.current?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  // 🧩 Check scroll position and toggle button visibility
  const listenToScroll = useCallback(() => {
    const scrollElement = scrollContainerRef.current;
    if (!scrollElement) return;

    setIsVisible(scrollElement.scrollTop > 512);
  }, [scrollContainerRef]);

  // const listenToScroll = () => {
  //   if (!scrollContainerRef.current) return;
  //   const winScroll = scrollContainerRef.current.scrollTop;
  //   setIsVisible(winScroll > 512); // show button after 512px scroll
  // };

  // 🧩 Add/remove scroll event listener on mount/unmount
  useEffect(() => {
    const scrollElement = scrollContainerRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", listenToScroll);
    }

    return () => {
      scrollElement?.removeEventListener("scroll", listenToScroll);
    };
  }, [scrollContainerRef, listenToScroll]);

  return (
    <div className="flex justify-center items-center">
      {isVisible && (
        // 🧩 Scroll-to-top button styling and interaction
        <div
          className="fixed bottom-16 right-8 z-[20] w-8 h-8 rounded-full flex justify-center items-center cursor-pointer text-base transition-transform hover:scale-110 hover:shadow-[5px_5px_30px_rgba(0,0,0,0.3)] active:scale-110 top-btn"
          onClick={goToBtnClick}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        >
          <FiChevronsUp />
        </div>
      )}
    </div>
  );
}

export default PageTop;
